export function ContactPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="text-3xl font-bold text-navy mb-4">Contact us</h1>
      <p className="text-navy-700 mb-6">
        Questions, feedback, partnership ideas — we want to hear from you.
      </p>
      <div className="card p-6 space-y-3">
        <Row label="General" value="hello@towshare.ca" href="mailto:hello@towshare.ca" />
        <Row label="Support" value="support@towshare.ca" href="mailto:support@towshare.ca" />
        <Row label="Press" value="press@towshare.ca" href="mailto:press@towshare.ca" />
        <Row label="Privacy" value="privacy@towshare.ca" href="mailto:privacy@towshare.ca" />
      </div>
      <p className="text-sm text-navy-500 mt-6">
        TowShare is operated by Waypoint Labs Inc., Ontario, Canada.
      </p>
    </div>
  );
}

function Row({ label, value, href }: { label: string; value: string; href: string }) {
  return (
    <div className="flex justify-between border-b border-navy-50 pb-2 last:border-0">
      <span className="text-navy-500">{label}</span>
      <a href={href} className="text-orange hover:underline">
        {value}
      </a>
    </div>
  );
}
